<template>
  <Transition
    name="bounce"
    mode="in-out"
    @before-enter="beforeEnter"
    @after-enter="afterEnter"
  >
    <slot />
  </Transition>
</template>

<script>
export default {
  methods: {
    beforeEnter (el) {

    },
    afterEnter (el) {

    },
  },
};
</script>
